import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminSidebar } from '../components/admin/AdminSidebar';
import { AdminOverview } from '../components/admin/AdminOverview';
import { PackageManager } from '../components/admin/PackageManager';
import { InvoiceManager } from '../components/admin/InvoiceManager';
import { TicketManager } from '../components/admin/TicketManager';
import { StaffManager } from '../components/admin/StaffManager';
import { ServerIntegrations } from '../components/admin/ServerIntegrations';
import { ThemeEditor } from '../components/admin/ThemeEditor';
import { CustomerManager } from '../components/admin/CustomerManager';
import { DomainManager } from '../components/admin/DomainManager';
import { PaymentGatewayManager } from '../components/admin/PaymentGatewayManager';
import { ContentManager } from '../components/admin/ContentManager';
import { CpanelImporter } from '../components/admin/CpanelImporter';
import { MaintenanceManager } from '../components/admin/MaintenanceManager';
import { DepartmentManager } from '../components/admin/DepartmentManager';
import { StaffChat } from '../components/admin/StaffChat';
export function AdminDashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return <div className="min-h-screen bg-slate-900 flex" data-id="element-1997">
      <AdminSidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} data-id="element-1998" />

      <main className="flex-1 lg:ml-64 pt-16 lg:pt-0" data-id="element-1999">
        <div className="p-6 md:p-10 max-w-7xl mx-auto" data-id="element-2000">
          <Routes data-id="element-2001">
            <Route path="/" element={<AdminOverview data-id="element-2003" />} data-id="element-2002" />
            <Route path="/packages" element={<PackageManager data-id="element-2005" />} data-id="element-2004" />
            <Route path="/invoices" element={<InvoiceManager data-id="element-2007" />} data-id="element-2006" />
            <Route path="/tickets" element={<TicketManager data-id="element-2009" />} data-id="element-2008" />
            <Route path="/staff" element={<StaffManager data-id="element-2011" />} data-id="element-2010" />
            <Route path="/servers" element={<ServerIntegrations data-id="element-2013" />} data-id="element-2012" />
            <Route path="/theme" element={<ThemeEditor data-id="element-2015" />} data-id="element-2014" />
            <Route path="/customers" element={<CustomerManager data-id="element-2017" />} data-id="element-2016" />
            <Route path="/domains" element={<DomainManager data-id="element-2019" />} data-id="element-2018" />
            <Route path="/gateways" element={<PaymentGatewayManager data-id="element-2021" />} data-id="element-2020" />
            <Route path="/content" element={<ContentManager data-id="element-2023" />} data-id="element-2022" />
            <Route path="/cpanel-import" element={<CpanelImporter data-id="element-2025" />} data-id="element-2024" />
            <Route path="/maintenance" element={<MaintenanceManager data-id="element-2027" />} data-id="element-2026" />
            <Route path="/departments" element={<DepartmentManager data-id="element-2029" />} data-id="element-2028" />
            <Route path="/chat" element={<StaffChat data-id="element-2031" />} data-id="element-2030" />
            <Route path="*" element={<Navigate to="/admin" replace data-id="element-2033" />} data-id="element-2032" />
          </Routes>
        </div>
      </main>
    </div>;
}